































import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component
export default class DialogContainer extends Vue {
    @Prop({ default: '' }) public headerTitle!: string;
    @Prop({ default: '506' }) public maxWidth!: string | number;
    @Prop({ default: 'true' }) public header!: boolean;
    @Model('change', { type: Boolean }) public show!: boolean;

    @Watch('show')
    public onShowChange(val: boolean) {
      this.$emit('change', val);
    }

    public close() {
      // emit to parent component to change the model
      this.$emit('change', false);
    }

    public onDialogClose() {
      // this will be called if dialog clossed by clicking outside of dialog
      this.close();
    }
}
